module.exports = __webpack_public_path__ + "img/tapestries.6109c7e7.webp";